import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Employee360Repository } from '../../../infrastructure/repositories/employee-360.repository';
import { GetEmployee360Query } from './get-employee-360.query';
import { GetEmployee360Result } from './get-employee-360.result';

/**
 * Get Employee 360 use case.
 * Loads an employee's profile and their combined case/investigation history.
 */
@Injectable({ providedIn: 'root' })
export class GetEmployee360UseCase {
  private readonly _repository = inject(Employee360Repository);

  public execute(query: GetEmployee360Query): Observable<GetEmployee360Result> {
    return this._repository.getEmployee360(query.userId).pipe(
      map((data) => ({
        profile: data?.profile ?? null,
        history: data?.history ?? [],
      })),
    );
  }
}
